/**
 * Authentication API Service
 * Handles all authentication-related API calls
 */

import apiClient from '../apiClient';
import { ENDPOINTS } from '../endpoints';

/**
 * Login user with credentials
 * @param {Object} credentials - { username, password }
 */
export const login = (credentials) =>
  apiClient.post(ENDPOINTS.AUTH.LOGIN, credentials);

/**
 * Logout current user.
 * Tokens are passed explicitly because auth storage is cleared before this
 * fire-and-forget call runs; without them the server could not revoke anything.
 * @param {string} accessToken - access token to revoke
 * @param {string} [refreshToken] - refresh token to revoke alongside it
 */
export const logout = (accessToken, refreshToken) =>
  apiClient.delete(ENDPOINTS.AUTH.LOGOUT, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    data: refreshToken ? { refreshToken } : undefined,
  });

/**
 * Refresh access token
 * @param {string} refreshToken
 */
export const refreshToken = (refreshTokenValue) =>
  apiClient.post(ENDPOINTS.AUTH.REFRESH, { refreshToken: refreshTokenValue });

/**
 * Request a password reset code by SMS
 * @param {Object} payload - { phone, recaptchaToken }
 */
export const passwordResetRequest = (payload) =>
  apiClient.post(ENDPOINTS.PASSWORD.RESET_REQUEST, payload);

/**
 * Confirm password reset
 * @param {Object} values - { phone, token, newPassword, confirmPassword }
 */
export const passwordResetConfirm = (values) =>
  apiClient.post(ENDPOINTS.PASSWORD.RESET_CONFIRM, values);

/**
 * Change password for authenticated user
 * @param {Object} values - { currentPassword, newPassword }
 */
export const changePassword = (values) =>
  apiClient.post(ENDPOINTS.PASSWORD.CHANGE, values);

